import { TradeOrder } from '../reducer/strategyBuilder.reducer'
import { getSecurityKey } from './security'

/** Compares trade legs ignoring transaction type (B/S toggle should not re-render controls). */
export const tradeOrdersEqualIgnoringTransactionType = (a: TradeOrder[], b: TradeOrder[]): boolean => {
    if (a === b) return true
    if (a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) {
        const left = a[i]
        const right = b[i]
        if (left.clientOrderId !== right.clientOrderId) return false
        if (left.quantity !== right.quantity) return false
        if (left.selected !== right.selected) return false
        if (left.price !== right.price) return false
        if (left.referenceOrderId !== right.referenceOrderId) return false
        if (getSecurityKey(left.security.exchange, left.security.code) !== getSecurityKey(right.security.exchange, right.security.code)) {
            return false
        }
    }
    return true
}

export const tradeOrderSecurityKeysSignature = (orders: TradeOrder[]): string =>
    orders
        .map((o) => getSecurityKey(o.security.exchange, o.security.code))
        .sort()
        .join('|')

export const tradeOrderClientOrderIdsSignature = (orders: TradeOrder[]): string =>
    orders.map((o) => o.clientOrderId).join('|')

/** Strategy-name API payload — includes transaction side. */
export const tradeOrdersStrategyLegsSignature = (orders: TradeOrder[]): string =>
    orders
        .map(
            (o) =>
                `${o.clientOrderId}:${getSecurityKey(o.security.exchange, o.security.code)}:${o.security.strikePrice ?? ''}:${o.security.expiry?.expiry ?? ''}:${o.quantity}:${o.transactionType}:${o.selected}`
        )
        .join('|')

/** Net signed qty per security for spread/chart links — changes on B/S toggle. */
export const tradeOrdersNetQtySignature = (orders: TradeOrder[]): string =>
    orders
        .map((o) => `${getSecurityKey(o.security.exchange, o.security.code)}:${o.transactionType}:${o.quantity}`)
        .sort()
        .join('|')

/** Selected legs + reference ids for trade-panel chrome that does not depend on B/S alone. */
export const tradeOrdersSelectionSignature = (orders: TradeOrder[]): string =>
    orders
        .map((o) => `${o.clientOrderId}:${o.selected}:${o.referenceOrderId ?? ''}:${o.price}:${o.quantity}`)
        .join('|')
